export default "__VITE_ASSET__hXDRvVW$__"